import React from 'react';

const Title: React.SFC<{}> = ({ children }) => (
  <h1 className="page-section__title" style={{ lineHeight: 1.3 }}>{children}</h1>
);

export default Title;
